"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _toggleOn = _interopRequireDefault(require("../../assets/icons/toggle-on.svg"));

var _toggleOff = _interopRequireDefault(require("../../assets/icons/toggle-off.svg"));

var _typography = _interopRequireDefault(require("../typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-switch-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem; }\n  .bds-switch-container .bds-switch {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    cursor: pointer; }\n    .bds-switch-container .bds-switch.disabled {\n      pointer-events: none;\n      opacity: 0.3; }\n  .bds-switch-container .bds-switch-error-message {\n    color: #da1e28; }\n";
  var fileName = "compone_switch";
  var element = document.querySelector("style[data-sass-component='compone_switch']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Switch = function Switch(_ref) {
  var _switchClasses;

  var disabled = _ref.disabled,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      checked = _ref.checked,
      label = _ref.label,
      onToggle = _ref.onToggle,
      width = _ref.width;
  var switchClasses = (_switchClasses = {}, _defineProperty(_switchClasses, _constants.classes.switch, true), _defineProperty(_switchClasses, _constants.classes.disabled, disabled), _switchClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.switchContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": _constants.classes.switch,
    className: (0, _classnames.default)(switchClasses),
    onClick: function onClick() {
      return onToggle(checked);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: checked ? _toggleOn.default : _toggleOff.default
  }), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, label)), error ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.switchErrorMessage,
    style: {
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, errorMessage)) : null);
};

Switch.propTypes = {
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  checked: _propTypes.default.bool,
  label: _propTypes.default.string,
  onToggle: _propTypes.default.func,
  width: _propTypes.default.number
};
var _default = Switch;
exports.default = _default;